import './HistogramTooltip.css';
export var wrapper = '_fzvydv0-3-12-1';